import { ReactNode } from "react";
import "./Footer.less";
export default function Footer({ children }: { children: ReactNode }) {
    return <div className="Footer">{children}</div>;
}
